export default __webpack_public_path__ + "static/media/smilingWoman.b5a37576.jpg";